import React, { useState } from 'react';
import { Mail, RefreshCw, Loader2, CheckCircle2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const EmailVerificationBanner = () => {
  const { user, isEmailVerified } = useAuth();
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  if (!user || isEmailVerified) return null;

  const handleResend = async () => {
    setResending(true);
    try {
      const res = await fetch(`${API}/api/auth/resend-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: user.email }),
      });
      if (res.status === 429) {
        toast.error('Please wait before requesting another email.');
      } else {
        setResent(true);
        toast.success('Verification email sent!');
      }
    } catch {
      toast.error('Failed to resend. Please try again.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div data-testid="email-verification-banner" className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-xl px-4 py-3 flex items-center justify-between gap-3 flex-wrap">
      <div className="flex items-center gap-2.5 min-w-0">
        <Mail className="w-4 h-4 text-amber-600 dark:text-amber-400 flex-shrink-0" />
        <p className="text-sm font-sans text-amber-800 dark:text-amber-200">
          Please verify your email <span className="font-semibold">{user.email}</span> to unlock all features.
        </p>
      </div>
      <button
        data-testid="banner-resend-btn"
        onClick={handleResend}
        disabled={resending || resent}
        className="flex items-center gap-1.5 text-sm font-semibold text-amber-700 dark:text-amber-300 hover:text-amber-900 dark:hover:text-amber-100 transition-colors whitespace-nowrap disabled:opacity-50"
      >
        {resending ? (
          <Loader2 className="w-3.5 h-3.5 animate-spin" />
        ) : resent ? (
          <CheckCircle2 className="w-3.5 h-3.5 text-green-600" />
        ) : (
          <RefreshCw className="w-3.5 h-3.5" />
        )}
        {resent ? 'Sent!' : 'Resend email'}
      </button>
    </div>
  );
};

export default EmailVerificationBanner;
